export enum EChatState {
  // first state = active chat, can send message and so on
  STARTED = 'Started',
  // second state, when the discussion was probably resolved but still can be continued, user can send message as well to proceed chat
  FINISHED = 'Finished',
  // third state, when the discussion was stopped at all, and not possible to continue
  STOPPED = 'Stopped',
}
